<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/Foreword#For">Foreword, by John T. Rhodes</a></p>
<p class="toc"><a href="#/Acknowledgements#Ack">Acknowledgements</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. DNA of a Tournament</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Getting Off the Ground</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Travel Basketball</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. A Player’s Tournament</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Paying for Prestige</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. The Curran Way</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Before Vinsanity</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Family Ties</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Local Struggles</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Hoops to Horry County</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. Expanding the Base</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. Preparing for the Future</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. Goodwill Games</span></p>
<p class="toc1"><span href="#/Beach" title="Link target outside of Sample">Beach Ball Classic Through the Years</span></p>
<p class="toc"><span href="#/Bibliography#Bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author#Aut" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?4a4f8eca